<div class="coming-soon-container" fxLayout="row" fxLayoutAlign="center center">
    <img src="assets/image/interface/home/logo.png"/>
    <button mat-raised-button color="warn" (click)="goBack()">Go Home</button>
</div>